<template>
  <div v-if="device" :class="{ active: opened.length > 0 }" class="side-box">
    <span class="side-box__overlay" />
    <div
      :class="{
        opened: opened.indexOf('changeService') >= 0,
        'last-active': opened.indexOf('changeService') == opened.length - 1
      }"
      class="side-box__inner"
    >
      <div class="side-box__header d-flex justify-content-between align-items-center">
        <div class="atom-back atom-back--gray" @click="toggleServiceConfiramtion()">
          <div class="atom-back__inner d-flex align-items-center">
            <img src="@/assets/icons/arrows/arr-gray-left.svg" />
            <span>{{ $t("zpet") }}</span>
          </div>
        </div>
        <button class="btn btn-primary" @click="changeService()">
          {{ $t("ulozitZmeny") }}
        </button>
      </div>
      <div class="side-box__title">
        <h2 v-if="device">
          {{ $t("ZměnitSluzbuPro") }}
          <span v-if="device.length > 1">{{ device.length }}</span>
          {{ $t("zarizeniPocet") }}
        </h2>
        <h3 v-if="device && device.length == 1">
          <span>{{ device[0].custDeviceName }}</span>
        </h3>
      </div>
      <div v-if="services.length > 0" class="side-box__content">
        <div class="side-box__row d-flex align-items-start mt-3">
          <span class="side-box__content__label gray-text-light mt-3">{{ $t("sluzba") }}</span>
          <div class="side-box__content__input custom-control__select disabled-with-result ml-3 mt-1">
            <div class="side-box__content__input">
              <div class="custom-control__select">
                <div
                  :class="{ opened: openedServiceSelect }"
                  class="custom-control__select__selected"
                  @click="openedServiceSelect = openedServiceSelect ? false : true"
                >
                  <span v-if="selectedService">
                    {{ selectedService.tarifName }}
                    <br />
                    <span class="text-smallest">{{ selectedService.custServiceId }}</span>
                  </span>
                </div>
                <div :class="{ opened: openedServiceSelect }" class="custom-control__select__options">
                  <div
                    v-for="(service, index) in services"
                    :key="index"
                    class="custom-control__select__option d-flex align-items-center"
                    @click="
                      () => {
                        selectedService = service
                        openedServiceSelect = false
                      }
                    "
                  >
                    <div v-if="service != null && selectedService != null" class="check">
                      <img
                        v-if="service.custServiceId === selectedService.custServiceId"
                        class=""
                        src="@/assets/icons/check.svg"
                      />
                    </div>
                    <span class="font-weight-light">
                      {{ service.tarifName }}
                      <br />
                      <span class="text-smallest">{{ service.custServiceId }}</span>
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <ServiceLimits v-if="selectedService.parameters" :service="selectedService" />

            <p class="mt-3">
              {{ $t("sluzbuMuzeteZmenit") }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <SaveConfirmationModal
      :opened="openedServiceChangeConfirmation"
      :text="'chceteUlozitProvedeneZmeny'"
      @close="toggleServiceConfiramtion"
      @no="closeBox()"
      @yes="changeService()"
    />
    <div v-if="errorsToTranslate.length > 0">
      <ErrorModal :centered="true" :errors="errorsToTranslate" :opened="openedError" @close="openedError = false" />
    </div>
  </div>
</template>

<script>
//import _ from "lodash";
import axios from "axios"
import SaveConfirmationModal from "@/components/confirmations/save.vue"
import ErrorModal from "@/components/confirmations/translatedErrors.vue"
import ServiceLimits from "@/components/boxes/serviceLimits.vue"
import { useProjectStore } from "@/store/modules/project"

export default {
  components: {
    SaveConfirmationModal,
    ErrorModal,
    ServiceLimits
  },
  props: {
    device: Array,
    opened: Array
  },
  setup() {
    const projectStore = useProjectStore()

    return { projectStore }
  },
  data() {
    return {
      openedServiceChangeConfirmation: false,
      errors: {
        device: "",
        group: ""
      },
      openedServiceSelect: false,
      selectedService: {},
      loaded: false,
      errorsToTranslate: [],
      openedError: false
    }
  },
  computed: {
    project() {
      return this.projectStore.selectedProject
    },
    services() {
      /**
       * we must use only service which is not suspended or discontinued
       */
      let storedServices = this.$store.getters["services/services"]
      let services = []
      for (let i = 0; i < storedServices.length; i++) {
        if (storedServices[i].suspended == false && storedServices[i].discontinued == false) {
          services.push(storedServices[i])
        }
      }
      return services
    }
  },
  watch: {
    project() {
      if (this.device) {
        this.$store.dispatch("services/getServices")
        //this.loadService();
      }
    },
    opened() {
      console.log("changeService", "opened")
      if (this.opened.indexOf("changeService") >= 0) {
        console.log("changeService", "opened indexof")
        this.loadService()
        console.log("changeService", "opened indexof after loadService")
        this.$store.dispatch("services/getServices")
      }
    },
    device() {
      /*
      console.log("changeService", "device");
      if (this.project) {
        console.log("changeService", "device if project");
        //this.loadService();
        this.$store.dispatch("services/getServices");
      }
      */
    }
  },
  mounted() {
    console.log("changeService", "opened")
    console.log("changeService", this.opened)
    console.log("changeService", this.opened.indexOf("changeService"))
    if (this.opened.indexOf("changeService") >= 0) {
      console.log("changeService", "opened indexof")
      this.loadService()
      console.log("changeService", "opened indexof after loadService")
      this.$store.dispatch("services/getServices")
    }
    //if (this.project && this.device) {
    /*this.loadService();
      this.$store.dispatch("services/getServices");*/
    //}
    //console.log("changeService", "mounted");
    //this.loadService();
  },
  methods: {
    openBox(box) {
      this.$emit("openBox", box)
    },
    closeBox(box) {
      if (box == undefined) {
        this.emptyValues()
        this.$emit("closeBox")
      } else {
        this.$emit("closeBox", box)
      }
    },
    loadService() {
      if (!this.device || !this.device.custServiceId) {
        return
      }
      console.log("changeService", "loadService")
      this.loaded = false
      axios
        .get(process.env.VUE_APP_API + "/services/" + this.device.custServiceId)
        .then((result) => {
          this.selectedService = result.data.data

          this.loaded = true
        })
        .catch(() => {})
    },
    changeService() {
      console.log("this.selectedService", this.selectedService)
      if (!this.selectedService) {
        return
      }

      this.$store.commit("modals/setWaitingLoader", this.$t("Ukládám data, čekejte prosím..."))

      this.errorsToTranslate = []

      let promises = []
      let notifications = []

      this.device.forEach((device) => {
        promises.push(
          axios
            .post(
              process.env.VUE_APP_API +
                "/services/" +
                this.selectedService.custServiceId +
                "/devices/lora/" +
                device.deviceId +
                "/assign"
            )
            .then((result) => {
              if (result.status == "success") {
                device.custServiceId = this.selectedService.custServiceId
              }

              notifications.push({
                text: this.$t("sluzbaZmenena"),
                error: false
              })
            })
            .catch((error) => {
              let message = error.data.errors[0]
              this.errorsToTranslate.push({
                message: message
              })
            })
        )
      })

      Promise.all(promises).then(() => {
        this.$store.commit("modals/setWaitingLoader", "")
        this.$store.commit("modals/setGlobalNotification", notifications)

        this.openedError = true

        this.closeBox()
        return true
      })
    },
    toggleServiceConfiramtion() {
      this.openedServiceChangeConfirmation = this.openedServiceChangeConfirmation ? false : true
    },
    emptyValues() {}
  }
}
</script>

<style lang="scss" scoped></style>
